module.exports = __webpack_public_path__ + "img/plx-logo@2x.1b68b856.png";